import {useTheme} from '@mui/material';
import React from 'react';
import {styled} from '@mui/material/styles';
import {useHeaderState} from './HeaderStateContext';
import {GetLogoInformation} from './types';
import {excludeComponentProps} from '../utils/excludeComponentProps';
import {headerCssClassNames} from './headerCssClassNames';

const logoCDN = 'https://cdn.ux.deere.com/brand-foundations/1.4.0/logos';

const StyledLogo = styled('img', {
    ...excludeComponentProps('variant')
})({
    marginRight: '24px'
});

const getLogoInformation: GetLogoInformation = (theme, variant = 'default', isMobile) => {
    const logoColor = theme.name === 'jdBlack' ? 'black' : 'green';

    const logoInformation = {
        bjd: {
            image: 'bjd-logo.svg',
            altText: 'Banco John Deere Logo'
        },
        jdf: {
            image: isMobile ? 'jdf-logo.svg' : 'jdf-inline-logo.svg',
            altText: 'John Deere Financial Logo'
        },
        default: {
            image: 'jd-logo.svg',
            altText: 'John Deere Logo'
        }
    }[variant];

    logoInformation.image = `${logoInformation.image}#${logoColor}`;

    return logoInformation;
};

export const HeaderLogo = React.forwardRef<HTMLImageElement, unknown>((_, ref) => {
    const theme = useTheme();
    const {
        variant, isSmallMobile,
        HeaderLogoProps
    } = useHeaderState();

    const imageInfo = getLogoInformation(theme, variant);
    const imageHeight = isSmallMobile ? '28px' : '32px';

    return (
        <StyledLogo
            alt={imageInfo.altText}
            ref={ref}
            src={`${logoCDN}/${imageInfo.image}`}
            {...HeaderLogoProps}
            className={headerCssClassNames.logo}
            height={imageHeight}
            width='auto'
        />
    );
});

HeaderLogo.displayName = 'HeaderLogo';
